
import { defineComponent, reactive, inject, watch } from "vue";

import { getInventory } from "@/request/view/dailyProduction";
import { getFQCInventory } from '@/request/view/warehouse';
import { defaultModel } from "@/views/productDaily/components/instruction/option";

import {
  PQCProductOption,
  modelSpecificationsOption,
  checkTypeInProject,
} from "@/views/productDaily/serve/option";
import { useTDArray } from "@/views/productionInstruction/server";
import { useRoute } from "vue-router";

interface model {
  label: string,
  value: string,
  col: number,
  data: Array<model>
}

type tableDataStd = Array<model>

export default defineComponent({
  props: {
    date: String,
    data: Object,
    type: String,
  },
  setup(props, content) {
    const route = useRoute();
    const widthSeetings = {
      windowWidth: window.screen.width - 280,
      broadsideWidth: 0,
      tablewidth: 588,
      maxCount: 3,
    };
    // 库存数据
    const inventoryData = reactive({});

    const tableData: any = reactive([]);

    const inventoryType = ["未检", "合格", "不合格"];

    // 库存初始化
    const initInventory = (type): tableDataStd => {
      const list = [];
      // 工序 取oqc fqc 之前的工序
      const typeList = props.type === 'fqc' ? PQCProductOption.filter((f) => f.label !== '包装') : PQCProductOption.filter((f) => f.label !== '包装' && f.label !== '成品');
      typeList.forEach((process) => {
        // 如果有传类型取单独的工序
        if (props.type && process.value !== props.type) return;
        const isProduce = process.value !== type;
        if (type && isProduce) {
          return;
        }
        const processData = {
          label: process.label,
          value: process.value,
          data: [],
          col: 0,
        };
        // 型号
        defaultModel.forEach((model) => {
          const modelData = {
            label: model.label,
            value: model.value,
            data: [],
            col: 0,
          };
          // 库存方式
          inventoryType.forEach((type) => {
            const typeData = {
              label: `${type}机身号`,
              value: type,
              data: [],
              col: 0,
            };
            modelData.data.push(typeData);
          });
          processData.data.push(modelData);
        });
        list.push(processData);
      });
      return list;
    };

    // FQC多型号处理
    const handleInsertFQCModel = (list, item) => {
      console.log(list, item, 'handleInsertFQCModel');
      const modelData = {
        label: item.modelSpecifications,
        value: item.modelSpecifications,
        data: [],
        col: 0,
      };
      // 库存方式
      inventoryType.forEach((type) => {
        const typeData = {
          label: `${type}机身号`,
          value: type,
          data: [],
          col: 0,
        };
        if (item.status === type) {
          typeData.data.push(item)
        }
        modelData.data.push(typeData);
      });
      list.push(modelData);

      return modelData;
    };

    // 设置工序数据
    const setProcessData = (project, key, data, initList) => {
      if (!data) return;

      Object.keys(data).forEach((key) => {
        data[key].forEach((item) => {
          // 工序
          const process = initList.find((f) => f.value === item.type);
          if (!process) return;
          let model = process.data.find(
            (f) => f.value === item.modelSpecifications
          );
          // fqc项目
          if (!model && item.type === "fqc" && !item.isUsed) {
            model = handleInsertFQCModel(process.data, item);
          } else if (model && item.type === "fqc" && !item.isUsed) {
            const type = model.data.find((f) => f.value === key);
            if (type) type.data.push(item);
            // 默认有项目
          } else if (model && item.type !== 'fqc' && !item.isToFQC) {
            const type = model.data.find((f) => f.value === key);
            if (type) type.data.push(item);
          }
        });
      });
    };

    const setInventoryTDarrry = (list: tableDataStd) => {
      list.forEach((process) => {
        process.data = useTDArray(widthSeetings, process.data);
      });
    };

    const getFQCInventoryData = async () => {
      return new Promise((resolve, reject) => {
        getFQCInventory({
          produceOrTpc: route.meta.produceOrTpc,
        }).then((res) => {
          resolve(res.data);
        }).catch((err) => {
          reject(err)
        });
      });
    }

    const getFQC = async () => {
      tableData.length = 0;
      const initList = initInventory(props.type);
      const FQCInventoryData = await getFQCInventoryData();

      Object.keys(FQCInventoryData).forEach((key) => {
        const project = checkTypeInProject(key);
        const fqcModelData = FQCInventoryData[key];

        Object.keys(fqcModelData).forEach((key) => {
          fqcModelData[key].forEach((item) => {
            item.outputSnNumber = item.serial;
            item.type = 'fqc'
          });
        });
        if (project) {
          setProcessData(project, key, fqcModelData, initList);
        }
      });

      setInventoryTDarrry(initList);

      tableData.push(...initList);
    }

    const getData = () => {
      tableData.length = 0;
      const initList = initInventory(props.type);
      getInventory({
        produceOrTpc: route.meta.produceOrTpc,
      }).then(async (res: any) => {
        if (res.code === 200 && res.message === "成功") {

          // 判断设备类型
          Object.keys(res.data).forEach((key) => {
            const project = checkTypeInProject(key);

            if (project) {
              setProcessData(project, key, res.data[key], initList);
            }
          });

          setInventoryTDarrry(initList);

          tableData.push(...initList);
        }
      });
    };

    const setInventory = (data) => {
      const list = initInventory(props.type);
      Object.keys(data).forEach((key) => {
        const project = checkTypeInProject(key);

        if (project) {
          setProcessData(project, key, data[key], list);
        }
      });

      setInventoryTDarrry(list);
      tableData.push(...list);
    };

    const tabActivekey = inject("tabActivekey", null);

    watch(
      () => tabActivekey,
      (val) => {
        if (val && val.value && val.value === "inventory" && props.type === 'fqc') {
          getFQC();
        } else if (val && val.value && val.value === "inventory") {
          getData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    watch(
      () => props.data,
      (val) => {
        tableData.length = 0;
        if (val) {
          setInventory(val);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      tableData,
      inventoryData,
      PQCProductOption,
      modelSpecificationsOption,
    };
  },
});
